<template>
<div class="monitor-container">
    <!-- 状态 + 过程：同一行 -->
    <Row type="flex" justify="start" align="middle" class="status-bar menu-actions">
        <Col flex="1">
        <div class="status-title">{{ getTranslation('r001') }}</div>
        <div><span class="sys-time">{{ sysTime }}</span></div>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': !stWork0Status[2], 'custom-radio-unchecked': stWork0Status[2] }"></Radio>

            </Col>
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': stWork0Status[2], 'custom-radio-unchecked': !stWork0Status[2] }"></Radio>
            </Col>
        </Row>
        <Row class="radio-labels-row">
            <Col flex="1" class="flex-middle"><span>手动</span></Col>
            <Col flex="1" class="flex-middle"><span>自动</span></Col>
        </Row>

        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': !stWork0Status[1], 'custom-radio-unchecked': stWork0Status[1] }"></Radio>
            </Col>
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': stWork0Status[1], 'custom-radio-unchecked': !stWork0Status[1] }"></Radio>
            </Col>
        </Row>
        <Row class="radio-labels-row">
            <Col flex="1" class="flex-middle"><span>检查</span></Col>
            <Col flex="1" class="flex-middle"><span>通电</span></Col>
        </Row>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': !stWork0Status[0], 'custom-radio-unchecked': stWork0Status[0] }"></Radio>
            </Col>
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': stWork0Status[0], 'custom-radio-unchecked': !stWork0Status[0] }"></Radio>

            </Col>
        </Row>
        <Row class="radio-labels-row">
            <Col flex="1" class="flex-middle"><span>联机</span></Col>
            <Col flex="1" class="flex-middle"><span>单机</span></Col>
        </Row>
        </Col>
        <Col flex="1" class="radio-buttons-col">
        <Row class="radio-buttons-row" type="flex">
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': !stWork0Status[3], 'custom-radio-unchecked': stWork0Status[3] }"></Radio>
            </Col>
            <Col flex="1" class="flex-middle">
            <Radio label="" disabled :class="{ 'custom-radio-checked': stWork0Status[3], 'custom-radio-unchecked': !stWork0Status[3] }"></Radio>

            </Col>
        </Row>
        <Row class="radio-labels-row">
            <Col flex="1" class="flex-middle"><span>工作</span></Col>
            <Col flex="1" class="flex-middle"><span>修磨</span></Col>
        </Row>
        </Col>
        <Col flex="5">
        <div class="process-row-wrapper">
            <span class="beat-label">{{getTranslation('a003')}}：{{ runningData.TmCycleAct  ? runningData.TmCycleAct/1000 : '--' }}{{getTranslation('a004')}}</span>
            <div class="process-bar">
                <div v-for="(p, idx) in phases" :key="p.bit" :class="['bar-segment', phaseClass(p.bit),
                            idx === 0 ? 'bar-first' : '',
                            idx === phases.length - 1 ? 'bar-last' : '']">
                </div>
            </div>
            <div class="process-labels">
                <span v-for="p in phases" :key="p.bit" :class="['step-text', phaseClass(p.bit)]">{{ p.label }}</span>
            </div>
        </div>
        </Col>
    </Row>

    <!-- 数据卡片区域：第1行 -->
    <Row :gutter="12" type="flex" class="cards-row">
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">{{getTranslation('b040')}}</div>
            <Row v-for="(item, key) in specFields" :key="key" :class="['field-row', key % 2 === 0 ? 'row-odd' : 'row-even']">
                <Col span="12" class="field-label">{{ item.label }}</Col>
                <Col span="12" class="field-value">{{ runningData[item.key] != null ? runningData[item.key] : '-'
                        }}</Col>
            </Row>
        </Card>
        </Col>
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">电极1产量</div>
            <Row :class="['field-row',  'row-odd' ]" type="flex">
                <Col flex="1" class="field-label">{{$lang['k193']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE1_CntPartSpot != null ? runningData.NvmE1_CntPartSpot : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',2)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-even' ]">
                <Col flex="1" class="field-label">{{$lang['k194']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE1_CntShift != null ? runningData.NvmE1_CntShift : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',0)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-odd' ]">
                <Col flex="1" class="field-label">{{$lang['a012']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE1_CntPartTotal != null ? runningData.NvmE1_CntPartTotal : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',3)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-even' ]">
                <Col flex="1" class="field-label">{{$lang['k196']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE1_CntSpotTotal != null ? runningData.NvmE1_CntSpotTotal : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',1)">清零</Button></Col>
            </Row>
            
        </Card>
        </Col>
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">电极2产量</div>
            <Row :class="['field-row',  'row-odd' ]" type="flex">
                <Col flex="1" class="field-label">{{$lang['k193']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE2_CntPartSpot != null ? runningData.NvmE2_CntPartSpot : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',10)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-even' ]">
                <Col flex="1" class="field-label">{{$lang['k194']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE2_CntShift != null ? runningData.NvmE2_CntShift : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',8)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-odd' ]">
                <Col flex="1" class="field-label">{{$lang['a012']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE2_CntPartTotal != null ? runningData.NvmE2_CntPartTotal : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',11)">清零</Button></Col>
            </Row>
            <Row :class="['field-row',  'row-even' ]">
                <Col flex="1" class="field-label">{{$lang['k196']}}</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE2_CntSpotTotal != null ? runningData.NvmE2_CntSpotTotal : '-'}}</Col>
                <Col flex="1"><Button type="primary" @click="normalControl('CmdStby0',9)">清零</Button></Col>
            </Row>

        </Card>
        </Col>
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">{{getTranslation('a014')}}</div>
            <Row v-for="(item, key) in currentFields" :key="key" type="flex" :class="['field-row', key % 2 === 0 ? 'row-odd' : 'row-even']">
                <Col flex="12" class="field-label">{{ item.label }}</Col>
                <Col flex="12" class="field-value">{{ runningData[item.key1] != null ? (runningData[item.key1]/100+"kA") : '-'
                        }}</Col>
                <Col flex="12" class="field-value">{{ runningData[item.key2] != null ? (runningData[item.key2]+"ms") : '-'
                        }}</Col>
            </Row>
        </Card>
        </Col>
    </Row>

    <!-- 数据卡片区域：第2行 -->
    <Row :gutter="12" class="cards-row" type="flex">
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">{{getTranslation('a015')}}</div>
            <Row :class="['field-row', 'row-odd']" type="flex">
                <Col flex="1" class="field-label">电极1剩余修磨焊点数</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE1_WeldLeft != null ? runningData.NvmE1_WeldLeft:'-' }}
                </Col>
                <Col flex="1"><Button type="primary">修磨</Button></Col>
            </Row>
            <Row :class="['field-row', 'row-odd']" type="flex">
                <Col flex="1" class="field-label">电极2剩余修磨焊点数</Col>
                <Col flex="1" class="field-value">{{ runningData.NvmE2_WeldLeft != null ? runningData.NvmE2_WeldLeft:'-' }}
                </Col>
                <Col flex="1"><Button type="primary">修磨</Button></Col>
            </Row>
        </Card>
        </Col>
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">{{getTranslation('a016')}}</div>
            <Row :class="['field-row', 'row-odd' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a016')}}</Col>
                <Col flex="12" class="field-value ">{{ runningData[pressureFields.average] != null ? runningData[pressureFields.average]/1000:'-' }} KN</Col>
            </Row>
            <Row :class="['field-row', 'row-even' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a019')}}</Col>
                <Col flex="12" class="field-value">{{ runningData[pressureFields.max] != null ? runningData[pressureFields.max]:'-' }}</Col>
            </Row>
            <Row :class="['field-row', 'row-odd' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a020')}}</Col>
                <Col flex="12" class="field-value">{{ runningData[pressureFields.min] != null ? runningData[pressureFields.min]:'-' }}</Col>
            </Row>
            <Row :class="['field-row', 'row-even' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('k197')}}</Col>
                <Col flex="12" class="field-value">{{ runningData[pressureFields.real] != null ? runningData[pressureFields.real]:'-' }}</Col>
            </Row>
        </Card>
        </Col>
        <Col flex="1">
        <Card dis-hover class="card-container">
            <div slot="title" class="card-title">{{getTranslation('a017')}}</div>
            <Row :class="['field-row', 'row-odd' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a017')}}</Col>
                <Col flex="12" class="field-value ">{{ runningData[meltFields.val] != null ? (runningData[meltFields.val]+'mm'):'-' }}</Col>
            </Row>
            <Row :class="['field-row', 'row-even' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a021')}}</Col>
                <Col flex="12" class="field-value">{{ runningData[meltFields.weldBefore] != null ? runningData[meltFields.weldBefore]:'-' }}</Col>
            </Row>
            <Row :class="['field-row', 'row-odd' ]" type="flex">
                <Col flex="12" class="field-label">{{getTranslation('a022')}}</Col>
                <Col flex="12" class="field-value">{{ runningData[meltFields.weldAfter] != null ? runningData[meltFields.weldAfter]:'-' }}</Col>
            </Row>
        </Card>
        </Col>
    </Row>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import {
    postJsError,
    int16toBit
} from '@/util/util'
import axios from 'axios';
import {
    API_URL
} from '@/constants/const'


export default {
    name: 'RealTime', // 组件名称
    components: {

    },
    props: {
        runningData: Object,

    },
    data() {
        return {
            mac:'',
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        phases() {
            return [{
                    label: this.$lang['a005'],
                    bit: 8
                },
                {
                    label: this.$lang['a006'],
                    bit: 9
                },
                {
                    label: this.$lang['a007'],
                    bit: 10
                },
                {
                    label: this.$lang['a008'],
                    bit: 12
                },
            ]
        },
        specFields() {
            return [{
                    label: this.$lang['a009'],
                    key: 'IdWeldPrg'
                },
                {
                    label: this.$lang['a010'],
                    key: 'SelPrgWeldID'
                },
                {
                    label: this.$lang['a011'],
                    key: 'material'
                },
            ]
        },
        production2Fields() {
            return [{
                    label: this.$lang['k193'],
                    key: 'NvmE2_CntPartSpot'
                },
                {
                    label: this.$lang['k194'],
                    key: 'NvmE2_CntShift'
                },
                {
                    label: this.$lang['a012'],
                    key: 'NvmE2_CntPartTotal'
                },
                {
                    label: this.$lang['k196'],
                    key: 'NvmE2_CntSpotTotal'
                },

            ]
        },
        currentFields() {
            return [{
                    label: this.$lang['b023'],
                    key1: 'AmpWeld1',
                    key2: 'TmWeld1'
                },
                {
                    label: this.$lang['b025'],
                    key1: 'AmpWeld2',
                    key2: 'TmWeld2'
                },
                {
                    label: this.$lang['b027'],
                    key1: 'AmpWeld3',
                    key2: 'TmWeld3'
                },
            ]
        },
        batteryFields() {
            return {
                val: 'powerCount'
            };

        },
        pressureFields() {
            return {
                average: 'IPrsWeldAvg',
                max: 'IPrsWeldMax',
                min: 'IPrsWeldMin',
                real: '',
            }

        },
        meltFields() {
            return {
                val: 'IPosWeldMelt',
                weldAfter: 'IPosWeldAfter',
                weldBefore: 'IPosWeldBefore',
            };
        },
        stWork0Status() {
            var number = 0
            if (this.runningData && this.runningData.StWork0) {
                number = this.runningData.StWork0
            }
            return int16toBit(number)
        },
        stFlow0Bits() {
            var number = 0
            if (this.runningData && this.runningData.StFlow0) {
                number = this.runningData.StFlow0
            }
            return int16toBit(number)
        },
        currentPhase() {
            var bits = this.stFlow0Bits
            if (bits[12] === 1) return 4
            if (bits[10] === 1) return 3
            if (bits[9] === 1) return 2
            if (bits[8] === 1) return 1
            return 0
        },
        sysTime() {
            var d = this.runningData
            if (!d || d.TmNowYear == null) return '----/--/-- --:--:--'
            var pad = function (n) {
                return (n < 10 ? '0' : '') + n
            }
            return d.TmNowYear + '-' + pad(d.TmNowMonth) + '-' + pad(d.TmNowDay) + ' ' + pad(d.TmNowHour) + ':' + pad(d.TmNowMin) + ':' + pad(d.TmNowSec)
        }
    },
    watch: {},

    created() {
        this.mac = this.$route.query.mac 
    },
    methods: {
        phaseClass(bit) {
            if (this.stFlow0Bits[bit] === 1) return 'phase-active'
            return 'phase-pending'
        },
        phaseIcon(bit) {
            if (this.stFlow0Bits[bit] === 1) return '●'
            return '○'
        },
        async download(changed){
          const url = API_URL['501CommuDownload'];
            // 计算与原始值的差异，只发送变更的字段（nil 指针 = 不写入）
            
            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(changed));
            let res = await axios.post(url, formData)
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
              // 写入成功，更新原始快照
              this.$Message.success(res.data.msg);
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },   
        async normalControl(key,offset){
            const val = 1 << offset
            let changed = {}
            changed[key] = val
            await this.download(changed)
        }
    },

}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.monitor-container {
    padding: 16px;
}

/* ========== 顶部联合栏 ========== */
.top-bar-row {
    margin-bottom: 20px;
    align-items: center;
}

/* --- 状态指示灯（圆形） --- */
.status-section {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 100%;
}

.status-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.4s ease;
}

.circle-on {
    background: linear-gradient(135deg, #19be6b 0%, #18a85e 100%);
    color: #fff;
    box-shadow: 0 2px 10px rgba(25, 190, 107, 0.4);
}

.circle-off {
    background: #e9ecef;
    color: #adb5bd;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.sys-time {
    font-size: 13px;
    color: #1677cc;
    margin-left: auto;
    white-space: nowrap;
    background: #e6f4ff;
    padding: 3px 10px;
    border-radius: 4px;
}

/* --- 过程进度条 --- */
.process-row-wrapper {
    display: flex;
    margin-left: 10px;
    flex-direction: column;
}

.beat-label {
    font-size: 13px;
    color: #495057;
    margin-bottom: 4px;
}

.process-bar {
    display: flex;
    height: 28px;
    border-radius: 14px;
    overflow: hidden;
    gap: 2px;
    background: #e9ecef;
    padding: 2px;
    margin-bottom: 6px;
}

.bar-segment {
    flex: 1;
    transition: background-color 0.5s ease, box-shadow 0.5s ease;
}

.bar-first {
    border-radius: 12px 0 0 12px;
}

.bar-last {
    border-radius: 0 12px 12px 0;
}

.bar-segment.phase-active {
    background: linear-gradient(180deg, #1c6fcf 0%, #1558a5 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
    animation: bar-pulse 1.8s ease-in-out infinite;
}

.bar-segment.phase-pending {
    background: transparent;
}

@keyframes bar-pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.75;
    }
}

.process-labels {
    display: flex;
    align-items: center;
    justify-content: center;
}

.step-text {
    flex: 1;
    text-align: center;
    font-size: 12px;
    transition: color 0.4s ease;
}

.step-text.phase-active {
    color: #1c6fcf;
    font-weight: 700;
}

.step-text.phase-pending {
    color: #adb5bd;
}

/* ========== 数据卡片 ========== */
.cards-row {
    margin-bottom: 12px;
}

.field-row {
    padding: 6px 8px;
    align-items: center;
}

.row-odd {
    background-color: #f8f9fa;
}

.row-even {
    background-color: #fff;
}

.field-label {
    font-size: 13px;
    color: #868e96;
    text-align: left;
    padding-left: 4px;
}

.field-value {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    text-align: right;
    padding-right: 4px;
}

.custom-radio-checked /deep/ .ivu-radio-inner {
    border-color: #19be6b !important;
    background-color: #19be6b !important;
}

.custom-radio-checked /deep/ .ivu-radio-inner:after {
    border-color: #fff !important;
}

.custom-radio-unchecked /deep/ .ivu-radio-inner {
    border-color: #dcdee2 !important;
    background-color: #f7f7f7 !important;
}

.ivu-radio-disabled {
    cursor: not-allowed !important;
}

.status-bar {
    margin-bottom: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.status-title {
    font-size: 16px;
    color: #495057;
}

.radio-buttons-col {
    border: 1px solid #dee2e6;
    padding: 4px;
}
</style>
